import { useEffect, useState } from "react";
import { _Inbox, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { ThirdBankingAccountEditor } from "../../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBanking.editor";
import { _SupplierPaymentOrder } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectorRPBudgetContract } from "../../../../../contract/etapa-contrato/contrac/adquisitionContractRP/SelectorRPBudgetContract";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { StepWizard, Wizard } from "../../../../config/Componentes/wizard/Wizard";
import { SupplierPaymentOrderItem } from "../../../../../Talentohumano/GestionTH/SupplierPaymentOrderItem/SupplierPaymentOrderItem";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const SOP011 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean } = useDataBean(_SupplierPaymentOrder);
    const [props, setProps] = useState<any>({});
    const [addBudget, setAddBudget] = useState<boolean>(true);
    const [infContrac, setInfContrac] = useState<any>({});
    const [response, setResponse] = useState<any>({});

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
        typeUpdateItem();
    }, [configProcedure?._pocessData])

    useEffect(() => {
        if (props.IDAdquisitionContract) {
            getAdquisitionContrac(props.IDAdquisitionContract)
            setBean({
                Type: 2,
                IDAdquisitionContract: props.IDAdquisitionContract,
                AdquisitionContractDate: props.ContractSeleccionDate,
                IDEmployee: _single.getAccountID(),
                SupplierPaymentOrderDate: _single.getCurrenDate()
            });
        }
    }, [props])

    const getAdquisitionContrac = (idContrac) => {
        instance.getAdquisitionContract(idContrac).then(
            (resp) => {
                setInfContrac(resp)
            }
        ).catch(
            err => {
                console.log(err)
            }
        )
    }

    const onExportMap = () => {

        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(response.Description)
        }

        if (configProcedure?._pushProps) {
            configProcedure?._pushProps(response)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(response)
        }

        toast.success(`Se ha creado la Orden de Pago`)
    }

    const formPaymentOrder = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <label>Fecha de Registro de la Orden de Pago</label>
                    <InputDate name=" " value={bean.SupplierPaymentOrderDate} setDate={(e) => { setBean({ ...bean, "SupplierPaymentOrderDate": e }) }} />
                </div>
                <div className="col-md-12">
                    <ThirdBankingAccountEditor label="Cuenta Bancaria del Tercero" idSelector={bean.IDThirdBankingAccount} idselectorAccount={props.IDAccountSupplier} onChange={(e) => { setBean({ ...bean, "IDThirdBankingAccount": e }) }} />
                </div>
                <div className="col-md-12">
                    <label>Justificación del Pago</label>
                    <textarea name="Description" className="form-control" rows={5} value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }} />
                </div>
                {addBudget &&
                    <div className="col-md-12">
                        <SelectorRPBudgetContract paymentDate={bean.SupplierPaymentOrderDate} adquisitionContract={props} onChange={(e) => { setBean({ ...bean, "RPIDDocument": e.IDDocument, "RPDocumentDate": e.DocumentDate }) }} label="Registro Presupuestal" />
                    </div>
                }
            </div>
        )
    }

    const typeUpdateItem = () => {
        instance.useBudget(null).then(
            (resp) => {
                setAddBudget(resp)
            }
        ).catch(
            err => {
                console.log(err)
                toast.error(err)
            }
        )
    }

    const editaItem = () => {
        if (bean.SupplierPaymentOrderDate && bean.IDThirdBankingAccount && bean.Description) {
            instance.updateSupplierPaymentOrder(bean).then(
                (resp: any) => {
                    // console.log(resp)
                    setBean(resp)
                }
            ).catch(err => {
                toast.error(err);
            })
        } else {
            toast.error("Los Campos son obligatorios")
        }
    }

    useEffect(()=>{},[response])

    const steps: StepWizard[] = [
        {
            keyID: "0",
            name: 'PASO 1. Formulario',
            onEvent: () => { },
            children:
                <div className="row">
                    <div className="col-md-12">
                        {formPaymentOrder()}
                    </div>
                    <div className="col-md-12 mt-4">
                        <BasicButton eventClick={editaItem} icon="ri-save-line" children={`${bean?.IDSupplierPaymentOrder ? "Actualizar" : "Crear Orden de pago"}`} />
                    </div>
                </div>
            ,
            validButton: bean?.IDSupplierPaymentOrder,
            canReturn: false
        },
        {
            keyID: "1",
            name: 'PASO 2. Items de la Factura',
            onEvent: () => { onExportMap()},
            children: <SupplierPaymentOrderItem SupplierPaymentOrder={bean} listLength={(e) => { setResponse({ ...response, "ItemsLength": e }) }} />,
            validButton: bean.ItemsLength > 0,
            canReturn: true
        },
    ]

    return (
        <>
            <div className="row">
                <div className="col-md-6">
                    <strong>Fecha del Contrato: </strong><small>{infContrac.AdquisitionContractDate}</small>
                </div>
                <div className="col-md-6">
                    <strong>Código Interno </strong><small>{infContrac.InternalCode}</small>
                </div>
                <div className="col-md-6">
                    <strong>valor del Contrato: </strong><small>{_single.formatMoney(infContrac.ContractValue)}</small>
                </div>
            </div>
            <Wizard title=" " listStep={steps} />
        </>
    )
}